export * from './ApplicationHero';

import { ApplicationHero } from './ApplicationHero';

export default ApplicationHero;
